import { render, staticRenderFns } from "./redeemItems.vue?vue&type=template&id=27e42a91&scoped=true&"
import script from "./redeemItems.vue?vue&type=script&lang=js&"
export * from "./redeemItems.vue?vue&type=script&lang=js&"
import style0 from "./redeemItems.vue?vue&type=style&index=0&id=27e42a91&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e42a91",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
